export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/3c7044d6-84c3-49f8-9cb4-40985f2f0c5f.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/0e7f8304-949e-44a5-863d-62e2ec684a1a.png',
};
